import React, { useMemo } from "react";
import { Container, Grid, Avatar, Box } from "@material-ui/core";
import useStyles from "./layoutNonMember.style";
import { useMidpoint } from "../../Helpers/hooks/useMidpoint";
import classnames from "classnames";

const LayoutNonMember = (props: any) => {
  const classes = useStyles();

  const { isMidpointHost } = useMidpoint();
  const logoPath = useMemo(
    () =>
      isMidpointHost
        ? "/2023_Midpoint_Logo_Vertical_RGB_White.png"
        : "/powered_by_taycor_logo_white.png",
    [isMidpointHost]
  );

  return (
    <Container maxWidth={false} disableGutters={true} className={classes.root}>
      <Grid container direction="column">
        <Grid item className={classes.content}>
          <Grid container>
            <Grid item className={classes.leftHalf}>
              <Box className={classes.leftHalfBackground}>
                <Avatar
                  variant="square"
                  src={logoPath}
                  className={classnames(classes.logo, {
                    [classes.logoMidpoint]: isMidpointHost,
                  })}
                ></Avatar>
              </Box>
            </Grid>
            <Grid item className={classes.rightHalf}>
              {props.children}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default LayoutNonMember;
